import React from "react";
import {IconButton} from "@mui/material";
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import { useThemeContext } from "../../contexts/ThemeContext";

function ThemeSwitcher() {

	const { toggleColorMode, darkMode } = useThemeContext();

  return (
		<>
			<IconButton
				aria-label="light"
				sx={{ borderRadius: "10px", p: 1 }}
				size="small"
				onClick={toggleColorMode}
			>
				{darkMode ? (
					<LightModeOutlinedIcon />
				) : (
					<DarkModeOutlinedIcon />
				)}
			</IconButton>
		</>
  );
}

export default ThemeSwitcher;
